import React from 'react';

import { BasketItem } from "store/basket/basketAPI";
import { removeItem } from "store/basket/basketSlice";
import { useAppDispatch } from "store";

import ExamItem from "./ExamItem";

type ExamsListProps = {
  exams: BasketItem[],
}

const ExamsList = ({ exams }: ExamsListProps) => {
  const dispatch = useAppDispatch();

  return (
    <>
      {exams.map((item) => (
        <ExamItem key={item.code} exam={item} onRemove={() => dispatch(removeItem(item.examOptionId))}/>
      ))}
    </>
  );
};

export default ExamsList;
